import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import FolderId from 'owa-service/lib/contract/FolderId';
import getCalendarFolderConfigurationOperation from 'owa-service/lib/operation/getCalendarFolderConfigurationOperation';
import GetCalendarFolderConfigurationResponse from 'owa-service/lib/contract/GetCalendarFolderConfigurationResponse';
import LinkedCalendarEntry from 'owa-service/lib/contract/LinkedCalendarEntry';
import { getCalendarEntryByFolderId } from 'owa-calendar-cache';
import { setExplicitLogonHeaders } from 'owa-headers';
import RequestOptions from 'owa-service/lib/RequestOptions';

/**
 * Makes the GetCalendarFolderConfiguration call to the server to get the CalendarFolder object
 * @param {FolderId} folderId id of the calendar's configuration that needs to be fetched
 * @param {string} email smtp addres of request mailbox
 * @returns promise of calendar folder object
 */
export async function getCalendarFolderConfigurationService(
    folderId: FolderId,
    email: string
): Promise<GetCalendarFolderConfigurationResponse> {
    let options: RequestOptions = {
        headers: setExplicitLogonHeaders(email),
    };

    let calendarEntry = getCalendarEntryByFolderId(folderId.Id) as LinkedCalendarEntry;

    // For a GS or group calendar we dont have the folder id there we use the DistinguisedFolderIdName
    let calculatedFolderId;
    if (
        calendarEntry &&
        (calendarEntry.IsGeneralScheduleCalendar || calendarEntry.IsGroupMailboxCalendar)
    ) {
        calculatedFolderId = distinguishedFolderId({
            Id: 'calendar',
            Mailbox: {
                EmailAddress: email,
            },
        });
    } else if (calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.PublicCalendarFolder) {
        calculatedFolderId = calendarEntry.SharedFolderId;
    } else {
        calculatedFolderId = folderId;
    }

    return await getCalendarFolderConfigurationOperation(
        {
            request: {
                FolderId: calculatedFolderId,
            },
        },
        options
    );
}
